

let selectedAppointment = "atelier";

function updateAppointment(product) {

  selectedAppointment = product;

  const data = window.appointmentProducts[product];

  const price = document.querySelector(".consultation-price");

  price.innerHTML = data.price;
  price.style.textAlign = "center";
  price.style.marginBottom = "25px";

  const description = document.querySelector(".consultation-description");

  description.innerHTML = data.description;
  description.style.textAlign = "center";

  description.querySelectorAll("*").forEach(function(element) {
    element.style.textAlign = "center";
  });
}


document.querySelectorAll(".consultation-toggle__button")
.forEach(button => {

  button.addEventListener("click", function(){

    document
    .querySelectorAll(".consultation-toggle__button")
    .forEach(btn => btn.classList.remove("active"));


    this.classList.add("active");


    updateAppointment(
      this.dataset.product
    );

  });

});


// Populate default selection on page load
updateAppointment("atelier");

